import MarketingSite from "@/components/marketing/MarketingSite";
import SEOHead from "@/components/seo/SEOHead";
import { OrganizationSchema } from "@/components/seo/StructuredData";

const Index = () => {
  return (
    <>
      <SEOHead 
        title="FlatJive: Less Hassle. More Harmony."
        description="FlatJive helps UK share of freehold owners collaborate effectively. Manage service charges, maintenance, documents, and decisions in one platform."
        keywords="share of freehold, property management, UK, service charges, flat management, freehold collaboration, property maintenance"
        canonicalUrl="https://flatjive.com/"
        type="website"
      />
      <OrganizationSchema includeWebSite={true} />
      <MarketingSite />
    </>
  );
};

export default Index;
